<div id="search-container">
  <div class="left icon">
    <ion-icon name="search-outline"></ion-icon>
  </div>

  <ion-textarea
    data-cy="searchbar"
    class="search"
    mode="md"
    enterkeyhint="search"
    placeholder="{{ placeholderSearch | translate }}"
    [(ngModel)]="searchKey"
    (paste)="onPaste()"
    (keydown.enter)="executeSearch($event)"
    (keydown.shift.enter)="executeSearch($event)"
    (ionClear)="resetSearch()"
    (ionInput)="onIonInput()"
    [class.small]="isSmallSearch"
    [class.large]="!isSmallSearch"
  >
  </ion-textarea>
  <div *ngIf="!!searchKey" (click)="resetSearch()" class="right icon">
    <ion-icon name="close-outline"></ion-icon>
  </div>
</div>
